import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class Text extends React.Component {
  static propTypes = {
    field: PropTypes.object,
    menu: PropTypes.bool
  }

  renderName(textSize) {
    let texto1 = this.props.field.name
    let texto2 = this.props.field.required ? '(Requerido)' : '(Opcional)'
    return this.getDiv(textSize, texto1 + " " + texto2);
  }

  renderValidation(textSize) {
    console.log("Validacion: " + JSON.stringify(this.props.field.validation));
    let texto1 = this.props.field.validation;
    let texto2 = this.props.field.required ? '(Requerido)' : '(Opcional)';
    return this.getDiv(textSize, texto1 + " " + texto2);
  }

  renderBlank(textSize) {
    let texto1 = "Texto "
    let texto2 = this.props.field && this.props.field.required ? '(Requerido)' : '(Opcional)'
    return this.getDiv(textSize, texto1 + texto2)
  }

  renderHeader() {
    return <div className={styles.container}>Texto</div>
  }
  
  getDiv(textSize, contenido){
      let style = styles.container
      console.log("GetDiv "+ textSize + " - " + contenido)
      if(textSize==='medium'){
        style += " " + styles.medium
      } else if( textSize==='large' ){
        console.log("ME Large size");
        style += " " + styles.large
      } 
      return <div className={style}>{contenido}</div>
  }

  render() {
    console.log("render Field: " + JSON.stringify(this.props.field));
    var textSize = "small"
    if(this.props.field && this.props.field.textSize){
        console.log("Viene textSize");
        if(this.props.field.textSize === 'medium'){
          textSize='medium'
        } else if(this.props.field.textSize === 'large'){
          textSize='large'
        }
    }
    console.log("textSize es " + textSize);

    if (this.props.menu) return this.renderHeader()
    if (this.props.field && this.props.field.value && this.props.field.value.text) {
      return this.getDiv(textSize, this.props.field.value.text)
    }
    if (this.props.field && this.props.field.name) return this.renderName(textSize)
    if (
      this.props.field &&
      this.props.field.validation &&
      this.props.field.validation !== 'ninguno'
    ) {
      return this.renderValidation(textSize)
    }
    if (!this.props.field) return this.renderBlank(textSize)
    if (!this.props.field.value) return this.renderBlank(textSize)
    if (!this.props.field.value.text) return this.renderBlank(textSize)
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Text/index.js